import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import styles from './Chart3.module.css'; // Import the CSS module


function Chart3() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false // Hides the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    yaxis: {
      title: {
        text: '$ (thousands)'
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "$ " + val + " thousands";
        }
      }
    },
    colors: ['#008FFB', '#00E396', '#775DD0'], // Use the color codes as per your image
    legend: {
      horizontalAlign: 'left',
      offsetX: 40
    }
  };

  const series = [
    {
      name: 'ADX',
      data: [23000, 19000, 22000, 27000, 13000, 22000, 33000]
    },
    {
      name: 'NasdaqDubai',
      data: [21000, 24000, 27000, 31000, 16000, 27000, 25000]
    },
    {
      name: 'DFM',
      data: [15000, 12000, 15000, 12000, 19000, 17000, 22000]
    }
  ];

  // Function to handle the dropdown selection
  const handleSelection = (selectedOption) => {
    // Logic for handling the selection
    console.log(selectedOption);
    setDropdownOpen(false);
  };

  return (
    <div>
      <div className={`${styles.first}`}>
        <div className={`${styles.second}`}>
        <h3>Overall</h3>
        <div style={{ position: 'relative' }}>
          <button onClick={() => setDropdownOpen(!dropdownOpen)} className={`${styles.third}`}>
            Last 1 Month ▼
          </button>
          {dropdownOpen && (
            <ul className={`${styles.four}`}>
              {/* Dropdown menu items */}
              <li className={`${styles.five}`} onClick={() => handleSelection('Last 1 Month')}>Last 1 Month</li>
              <li className={`${styles.five}`} onClick={() => handleSelection('Last 3 Months')}>Last 3 Months</li>
              <li className={`${styles.five}`} onClick={() => handleSelection('Last 6 Months')}>Last 6 Months</li>
              <li className={`${styles.five}`} onClick={() => handleSelection('Last 1 Year')}>Last 1 Year</li>
            </ul>
          )}
        </div>
        </div>
      </div>
      <Chart options={chartOptions} series={series} type="bar" height={350} />
    </div>
  );
}

export default Chart3;
